import React, { Component } from 'react'
import {
	Spin,
	Divider,
	Alert,
} from 'antd'
// import debounce from 'lodash/debounce'
import WarehousesForm from './WarehousesForm';
import API from '../../../services/API'
// import { objectToFormData } from '../../../services/Utils'

// const Option = Select.Option

const INITIAL_DATA = {
	name: '',
	type: '',
    has_inventory: '',
    // subsidiary_id: '',
}

class WarehousesEditContainer extends Component {
	constructor(props) {
        super()
        const { id } = props.match.params;
        this.id = id;
    }

    id = null;

	// eslint-disable-next-line react/state-in-constructor
	state = {
		data: INITIAL_DATA,
		loading: false,
        response: null,
        editFormData: {},
        manager: {},
        suburb: {},
        managers: {
            data: [],
        },
        suburbs: {
            data: [],
        },
	}

	componentDidMount() {
		this.getAdditionalData()
	}

	getAdditionalData = () => {
        API.get(`/api/warehouses/${this.id}?include=subsidary`)
            .then((response) => {
				// eslint-disable-next-line prefer-const
				let keys = Object.keys(INITIAL_DATA);
				// eslint-disable-next-line prefer-const
				let tmpData = {};
                // eslint-disable-next-line no-plusplus
                for (let index = 0; index < keys.length; index++) {
					const element = keys[index];
					if (element === 'active') {
				
						tmpData[element] = {
							value: false,
							errors: [],
						}
					} else {
						tmpData[element] = {
							value: response.data[element],
							errors: [],
						}
					}
				}
				const toState = {
					editFormData: tmpData,
					subsidiary: response.data.subsidiary ? response.data.subsidiary : null,
                    isLoaded: true,
				};
				this.setState(toState);
                // this.setState({
				// 	editFormData: tmpData,
				// 	subsidiary: response.data.subsidiary ? response.data.subsidiary : null,
                //     isLoaded: true,
				// });
            })
            .catch((err) => {
                console.error(err);
            });
	}

	save = async (data) => {
		await this.setState({
			loading: true,
			response: null,
		})

		const state = {
			...this.state,
			loading: false,
		}

		try {
			// eslint-disable-next-line no-unused-vars
			const response = await API.put(`/api/warehouses/${this.id}`, data)
			state.response = {
				type: 'success',
				message: 'Los cambios se hicieron con exito!',
			}
		} catch (error) {
			state.response = {
				type: 'error',
				message: error.response
					? error.response.data.message
					: 'Se produjo un error de conexión',
			}
		}

		this.setState({
			...state,
		})
	}

	getValuesForm = (values) => {
		const formKeys = Object.keys(values);
		// eslint-disable-next-line prefer-const
		let newFormToSend = {};
		// eslint-disable-next-line no-plusplus
		for (let index = 0; index < formKeys.length; index++) {
			const element = values[formKeys[index]];
			if (formKeys[index].includes('_id') && element.key) {
				newFormToSend[formKeys[index]] = element.key;
			} else {
				newFormToSend[formKeys[index]] = element;
			}
		}
        this.save(newFormToSend)
	}

	render() {
		return (
			// eslint-disable-next-line react/jsx-fragments
			<React.Fragment>
				<div
					style={{
						backgroundColor: 'white',
						borderRadius: 3,
						padding: '8px 16px 16px',
					}}
				>
					<Spin
						spinning={this.state.loading}
						tip="Espere, por favor..."
					>
						<>
							{this.state.response && (
								<Alert
									message={
										this.state.response.type === 'success'
											? 'Éxito'
											: 'Error'
									}
									description={this.state.response.message}
									type={this.state.response.type}
									showIcon
									closable
									onClose={() => this.setState({ response: null })}
								/>
							)}
							<Divider>Editar almacen</Divider>

                            {
                                this.state.isLoaded ? (
                                    <WarehousesForm
										getValuesForm={this.getValuesForm}
										id={this.id}
										fields={this.state.editFormData}
										subsidiary={this.state.subsidiary}
                                    />
                                ) : (null)
                            }

						</>
					</Spin>
				</div>
			</React.Fragment>
		)
	}
}

export default WarehousesEditContainer
